import React, { useMemo } from 'react';
import { TypedMemo } from '../../../common/types';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { assetWorkRow, reelWorkRow } from '../work/studioWorkModel';
import { WorkRowFailedAction } from '../work/WorkRowFailedAction';
import { PostsBoardFile, webAssetOf, webReelOf } from './postsModel';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Posts.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostsFailedActionProps {
  accountId: number;
  file: PostsBoardFile;
  catalogItem: CatalogItem;
}

/**
 * "Try again" of a failed file in the Making strip (design assets-rethink c1): the button of the
 * Work row (`WorkRowFailedAction`). A kit asset is made again; a reel opens its page in the Studio;
 * a master that cannot be used opens the catalog; a spent Free AI budget opens the upgrade.
 */
const PostsFailedActionComponent: React.FC<PostsFailedActionProps> = ({ accountId, file, catalogItem }) => {
  const row = useMemo(() => {
    const asset = webAssetOf(file);
    if (asset !== null) {
      return assetWorkRow(asset);
    }
    const reel = webReelOf(file);
    return reel === null ? null : reelWorkRow(reel);
  }, [file]);
  if (row === null) {
    return null;
  }
  return (
    <WorkRowFailedAction
      accountId={accountId}
      row={row}
      catalogItem={catalogItem}
      releaseTab="posts"
      className={styles.link}
      testID="posts-retry"
    />
  );
};

export const PostsFailedAction = TypedMemo(PostsFailedActionComponent);
